import type {
  ActivitySuggestion,
  ActivitySuggestionsResponse,
  GraphQL,
} from '@libs/trip-planner-interfaces';

import { assertSmartSearchValue } from '../../utils';

import { toMoney } from './moneyResponseQL';

export function toActivitySuggestionsResponse(
  suggestedActivityResponseQL: GraphQL.GetSuggestedQuery,
  ingredientIndex: number
): ActivitySuggestionsResponse {
  assertSmartSearchValue(suggestedActivityResponseQL.getSuggestedAvailability);
  const suggestedActivityResponse =
    suggestedActivityResponseQL.getSuggestedAvailability;

  if (!suggestedActivityResponse.results) {
    return {
      suggestions: [],
      ingredientIndex,
    };
  }
  const suggestions = suggestedActivityResponse.results.map(
    (suggestion): ActivitySuggestion => {
      const suggestionPrice = toMoney(suggestion.totalPrice);

      return {
        code: suggestion.code,
        price: suggestionPrice,
      };
    }
  );

  return {
    suggestions,
    ingredientIndex,
  };
}
